/* eslint-disable @typescript-eslint/no-explicit-any */
import { getService } from 'azure-devops-extension-sdk';
import { IdentityServiceIds, IVssIdentityService, } from 'azure-devops-extension-api/Identities';

export async function getIdentities() {
	const client = await getService<IVssIdentityService>(IdentityServiceIds.IdentityService);
	const identities = await client.getIdentityMruAsync();
	return identities;
}

export async function searchIdentities(text: string, options?: { withGroup?: boolean, queryTypeHint?: string }) {
	const client = await getService<IVssIdentityService>(IdentityServiceIds.IdentityService);
	if (options && options?.withGroup) {
		return await client.searchIdentitiesAsync(text, ['user', 'group'], undefined, options?.queryTypeHint);
	}

	return await client.searchIdentitiesAsync(text, ['user'], undefined, options?.queryTypeHint);
}